import gql from 'graphql-tag';

export const CLOSE_DEAL = gql`
  mutation CloseDeal($input: CloseDealInput!) {
    bpf {
      result: closeDeal(input: $input) {
        success
        error
      }
    }
  }
`;
